import { render, staticRenderFns } from "./TextMe.vue?vue&type=template&id=2923af36&scoped=true&"
import script from "./TextMe.vue?vue&type=script&lang=js&"
export * from "./TextMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923af36",
  null
  
)

export default component.exports